const routes = {
  admin: {
    auctionPayment: "Anzeigeprovision",
    documents: "Dokumente zur Überprüfung",
    profile: "Profil",
    adverts: "Anzeigen",
    profile_settings: "Profileinstellungen",
    companies: "Unternehmen",
    time_window: "Avisierungen",
    workers: "Mitarbeiter",
    invoices: "Rechnungen",
    tenders: "Ausschreibungen",
    price: "Preisliste",
    subscription: "Abonnement",
    company: "Firma",
    department: "Abteilung",
    group_chat: "Gruppennachricht",
    group_chats: "Gruppen-Chats",
    chats: "Chats",
    chat: "Chat",
    raports: "Berichte",
    add_worker: "Mitarbeiter hinzufügen",
    add_wroker_to_department: "Mitarbeiter zur Abteilung hinzufügen",
    add_vehicle: "Fahrzeug hinzufügen",
    add_documents: "Dokumente hinzufügen",
    add_department: "Abteilung hinzufügen",
    factoring: "Factoring-Verzeichnis",
    auctions: "Auftragsbörse",
    users: "Benutzer",
    verificationPayments: "Verifizierungstransfers",
  },
  auth: {
    register: "Registrierung",
    login: "Anmeldung",
    forgot_password: "Passwort vergessen",
    reset_password: "Passwort ändern",
    verification: "Kontoverifizierung",
    confirm_registration: "Registrierung bestätigen",
  },
  not_found: "Seite nicht gefunden",
  user: {
    add_offer: "Angebot hinzufügen",
    add_driver: "Fahrer hinzufügen",
    "pilot-offers": "Pilotenbörse",
    "pilot-offer-mine": "Meine Pilotenangebote",
    "pilot-offer-adding": "Freies Pilotenangebot hinzufügen",
    dashboard: "Dashboard",
    profile: "Mein Profil",
    company: "Firma",
    settings: "Einstellungen",
    add_document: "Dokument hinzufügen",
    add_worker: "Mitarbeiter hinzufügen",
    add_warehouse: "Lager hinzufügen",
    add_department: "Abteilung hinzufügen",
    workers: "Mitarbeiter",
    warehouses: "Lager",
    departments: "Abteilungen",
    calendar: "Kalender",
    fill_calendar: "Kalender ausfüllen",
    pick_calendar: "Kalender auswählen",
    edit_day: "Tag bearbeiten",
    add_user: "Benutzer hinzufügen",
    language: "Sprache",
    driver_departments: "Liste der Spediteure",
    department_details: "Abteilungsdetails",
    documents: "Dokumentenliste",
    department_workers: "Abteilungsmitarbeiter",
    warehouse_workers: "Lagermitarbeiter",
    department_invite: "Abteilungseinladung",
    authorization: "Autorisierung",
    authorizations: "Autorisierungen",
    add_car: "Auto hinzufügen",
    cars: "Autos",
    insurances: "Versicherungen",
    add_monitary: "Avisierung",
    car_statuses: "Autostatus",
    accept_monitary: "Avisierung bestätigen",
    finish_monitary: "Avisierung abschließen",
    monitary_list: "Avisierungsliste",
    monitary_archive: "Avisierungsarchiv",
    monitary_edit: "Avisierung bearbeiten",
    stock: "Auftragsbörse",
    add_auction: "Auftrag hinzufügen",
    wallet: "Meine Brieftasche",
    payment_processing: "Zahlungsverarbeitung",
    widgets_settings: "Widget-Einstellungen",
    notifications: "Benachrichtigungen",
    chat_list: "Nachrichten",
    chat: "Chat",
    offers: "Zugewiesene Aufträge",
    won_auctions: "Zugewiesene Transporte",
    lost_auctions: "Nicht erhaltene Transporte",
    canceled_transports: "Stornierte / nicht erhaltene Transporte",
    current_auctions: "Laufende Aufträge",
    surcharges: "Aktuelle Zuschläge",
    my_auctions: "Meine Aufträge",
    auction_archive: "Auftragsarchiv",
    edit_auction: "Ausschreibung bearbeiten",
    cancelled_auctions: "Stornierte Aufträge",
    contract_terms: "Vertragsbedingungen",
    group_making: "Gruppenerstellung",
    participants_list: "Teilnehmerliste",
    added_driver_groups: "Erstellte Pilotengruppen",
    invoices: "Rechnungen",
    blocked_users: "Blockierte Benutzer",
    factoring: "Factoring",
  },
};

export default routes;
